


































































































































































import { ContactApi } from "../api/ContactApi";
import { Contact } from "../models/Contact";
import CollapsiblePanel from "../core/UI/CollapsiblePanel.vue";
import TextInput from "../core/Forms/TextInput.vue";
import { ListParamApi } from "../api/ListParamApi";
import { Option } from "../models/Option";
import OptionSelect from "../core/Forms/OptionSelect.vue";
import TextareaInput from "../core/Forms/TextareaInput.vue";
import ContactCoordsEdit from "./ContactCoordsEdit.vue";
import ContactTagEdit from "./ContactTagEdit.vue";
import ContactSelect from "../core/Forms/ContactSelect.vue";
import ContactCoordonnesList from "./ContactCoordonnesList.vue";
import { URLUtils } from "../utils/URLUtils";
import ContactFacturesList from "./ContactEditPartials/ContactFacturesList.vue";
import ClientFusionModal from "./ClientFusionModal.vue";

export default {
    name: "ContactEdit",
    components: {
        ClientFusionModal,
        ContactFacturesList,
        ContactCoordonnesList,
        ContactSelect,
        TextareaInput,
        OptionSelect,
        TextInput,
        CollapsiblePanel,
        ContactCoordsEdit,
        ContactTagEdit,
    },
    props: {
        contactId: Number,
    },
    data() {
        return {
            contact: null,
            adresse: null,
            selectedSyndic: null,
            contactTypes: {},
            categories: {},
            syndicSelectFilters: [Contact.EType.Syndic],
            ContactApi: new ContactApi(),
            ListParamApi: new ListParamApi(),
            saving: false,
            showMap: false,
            showFusionModal: false,
        };
    },
    created() {
        let self = this;
        if (self.contactId) {
            self.ContactApi.get(self.contactId, {
                include:
                    "related_contacts,owned_contacts,factures_fournisseurs",
            }).then(function (response) {
                self.contact = response;
                self.adresse = self.contact.adresse;
                let syndicData = _.first(self.contact.related_contacts);
                if (syndicData) {
                    self.selectedSyndic = new Contact(syndicData);
                }
            });
        } else {
            self.contact = new Contact({});
            self.adresse = {};
            let urlParams = URLUtils.getUrlParams();
            if (urlParams) {
                if (urlParams.get("nom")) {
                    self.contact.nom = urlParams.get("nom");
                }
            }
        }
        self.ListParamApi.getAll({
            type: Option.EListParamType.type_client,
        }).then(function (res) {
            self.contactTypes = Option.arrToOptions(res);
            let urlParams = URLUtils.getUrlParams();
            if (urlParams && urlParams.get("type")) {
                let type = _.find(self.contactTypes, {
                    name: urlParams.get("type"),
                });
                self.contact.type_id = type.id;
            }
        });
        self.ListParamApi.getAll({
            type: Option.EListParamType.category_client,
        }).then(function (res) {
            self.categories = Option.arrToOptions(res);
        });
    },
    computed: {
        isSyndic: function (): boolean {
            let param = _.find(this.contactTypes, { id: this.contact.type_id });
            return param && param.name == Contact.EType.Syndic;
        },
        isClient: function (): boolean {
            let param = _.find(this.contactTypes, { id: this.contact.type_id });
            return (
                param &&
                (param.name == Contact.EType.Copropriete ||
                    param.name == Contact.EType.Syndic ||
                    param.name == Contact.EType.Particulier ||
                    param.name == Contact.EType.Bureau)
            );
        },
        isFournisseur: function (): boolean {
            let param = _.find(this.contactTypes, { id: this.contact.type_id });
            return (
                param &&
                (param.name == Contact.EType.Fournisseur ||
                    param.name == Contact.EType.Prestataire)
            );
        },
        exitLink: function (): string {
            if (this.isFournisseur) {
                return "#/app/fournisseur";
            } else {
                return "#/app/client";
            }
        },
    },
    methods: {
        updateCoords: function (coord) {
            this.adresse.coord.lat = coord.lat;
            this.adresse.coord.lng = coord.lng;
        },
        updateTags: function (newTags) {
            this.contact.tags = newTags;
        },
        /**
         * Après une fusion, la fiche du Client conservé, rechargée : ce peut
         * être celle-ci.
         */
        ouvrirClientConserve: function (conserve) {
            this.showFusionModal = false;
            if (conserve.id === this.contact.id) {
                window.location.reload();
            } else {
                window.location.href = conserve.link;
            }
        },
        saveContact: function () {
            let self = this;
            self.saving = true;
            if (self.selectedSyndic && self.selectedSyndic.id) {
                self.contact.syndic_id = self.selectedSyndic.id;
            }
            self.ContactApi.save(self.contact).then(function (response) {
                self.contact = response;
                self.ContactApi.saveAdresse(self.contact.id, self.adresse).then(
                    function () {
                        self.saving = false;
                        window.location.href = self.exitLink;
                    }
                );
            });
        },
    },
};
